import { render, staticRenderFns } from "./CurrencyForm.vue?vue&type=template&id=99f205aa"
import script from "./CurrencyForm.vue?vue&type=script&lang=js"
export * from "./CurrencyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports